export default {
	namespaced: true,
	// modules: {}
	state: {
		// 訂單列表
		list: [],
		finishOrder: false,
	},
	mutations: {
		SET_LIST($, val) {
			$.list = val
		},
		SET_FINISH_ORDER($, val) {
			$.finishOrder = val
		},
	},
	actions: {},
}
